import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { Observable } from 'rxjs';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { map, startWith, take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { ActivatedRoute } from '@angular/router';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd001-card-limpeza-IV',
    templateUrl: './cd001-card-limpeza-IV.component.html'
})

export class Cd001CardLimpezaIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listPresencaSabugoPedunculo: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaFundo: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaPoExcesso: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaOutrosCultivares: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaSabugoPedunculoOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaFundoOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaPoExcessoOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaOutrosCultivaresOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    @Output() mkCalc = new EventEmitter();

    area: string = eAreaType.commercial;
    isBasic: boolean = false;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, private route: ActivatedRoute) {
        super('Análise da Fração de Sementes boas da Pré-Limpeza', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                presenca_sabugo_pedunculo: [null, []],
                presenca_fundo: [null, []],
                presenca_po_excesso: [null, []],
                presenca_outros_cultivares: [null, []],
                usuario: [null, []],
                observacoes: [null, []],
                total_defeitos_prc: [null, []],
                total_defeitos_g: [null, []],
                peso_hectolitrico_fracao_boa: [null, []],
                peso_hectolitrico_fracao_descarte: [null, []],
                diferenca_peso_hectolitrico: [null, []],
                peso_semente_boa_descarte_g: [null, []],
            });
        }
        else {
            this.formulario = this.formBuilder.group({
                presenca_sabugo_pedunculo: [null, []],
                presenca_fundo: [null, []],
                presenca_po_excesso: [null, []],
                presenca_outros_cultivares: [null, []],
                usuario: [null, []],
                observacoes: [null, []],
                total_defeitos_prc: [null, []],
                total_defeitos_g: [null, []],
                peso_hectolitrico_fracao_boa: [null, []],
                peso_hectolitrico_fracao_descarte: [null, []],
                diferenca_peso_hectolitrico: [null, []],
                peso_semente_boa_descarte_g: [null, []],
                resultado: [null, []],
                existe_descarte_massa_boa: [null, []],

            });
        }

    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
        this.getArea();
        this.formChanges();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }




    async getLists(): Promise<void> {
        await this.getListSimNao();
    }

    private async getListSimNao(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listPresencaSabugoPedunculo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPresencaFundo = this.listPresencaSabugoPedunculo;
                this.listPresencaPoExcesso = this.listPresencaSabugoPedunculo;
                this.listPresencaOutrosCultivares = this.listPresencaSabugoPedunculo;
                this.listPresencaSabugoPedunculoOriginal = this.listPresencaSabugoPedunculo;
                this.listPresencaFundoOriginal = this.listPresencaFundo;
                this.listPresencaPoExcessoOriginal = this.listPresencaPoExcesso;
                this.listPresencaOutrosCultivaresOriginal = this.listPresencaOutrosCultivares;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async createFilterPresencaSabugoPedunculo(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPresencaSabugoPedunculoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPresencaSabugoPedunculo = this.listPresencaSabugoPedunculoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPresencaSabugoPedunculo = this.listPresencaSabugoPedunculoOriginal;
            }
        } else {
            this.listPresencaSabugoPedunculo = this.listPresencaSabugoPedunculoOriginal;
        }
    }

    async createFilterPresencaFundo(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPresencaFundoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPresencaFundo = this.listPresencaFundoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPresencaFundo = this.listPresencaFundoOriginal;
            }
        } else {
            this.listPresencaFundo = this.listPresencaFundoOriginal;
        }
    }

    async createFilterPresencaPoExcesso(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPresencaPoExcessoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPresencaPoExcesso = this.listPresencaPoExcessoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPresencaPoExcesso = this.listPresencaPoExcessoOriginal;
            }
        } else {
            this.listPresencaPoExcesso = this.listPresencaPoExcessoOriginal;
        }
    }

    async createFilterPresencaOutrosCultivares(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPresencaOutrosCultivaresOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPresencaOutrosCultivares = this.listPresencaOutrosCultivaresOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPresencaOutrosCultivares = this.listPresencaOutrosCultivaresOriginal;
            }
        } else {
            this.listPresencaOutrosCultivares = this.listPresencaOutrosCultivaresOriginal;
        }
    }



    getArea = () => {
        this.route.paramMap.subscribe((paramMap) => {
            this.area = paramMap.get('area');
        });
    };

    formChanges = () => {
        switch (this.area) {
            case eAreaType.basic:
                this.isBasic = true;
                // this.formulario.controls.peso_semente_boa_descarte_g.disable();
                this.formulario.controls.total_defeitos_g.disable();
                break;
            default:
                this.isBasic = false;
                // this.formulario.controls.peso_semente_boa_descarte_g.enable();
                this.formulario.controls.total_defeitos_g.enable();
                break;
        }
    };


}
